import { Link } from 'react-router-dom';
import SectionHeading from '@/components/base/SectionHeading';
import FaqAccordion from '@/components/feature/FaqAccordion';
import { FAQ_GROUPS } from '@/mocks/faq';

export default function FaqPreview() {
  const preview = FAQ_GROUPS.flatMap((g) => g.items).slice(0, 4);

  return (
    <section id="faq-preview" className="w-full px-4 md:px-6 py-16 md:py-24 bg-background-50" aria-labelledby="faq-preview-heading">
      <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-12 gap-10">
        <div className="lg:col-span-4">
          <SectionHeading
            id="faq-preview-heading"
            eyebrow="FAQ"
            title="先把最常问的四个问题说清"
            desc="关于截稿时间、投票权重、公示与申诉的疑问，这里先给结论，完整版在常见问题页。"
          />
          <Link
            to="/faq"
            className="mt-6 inline-flex items-center gap-2 px-5 py-2.5 rounded-md bg-secondary-500 text-background-50 text-sm font-medium whitespace-nowrap hover:bg-secondary-600 transition-colors cursor-pointer"
          >
            查看全部常见问题
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
        <div className="lg:col-span-8">
          <FaqAccordion items={preview} defaultOpenId={preview[0]?.id} />
        </div>
      </div>
    </section>
  );
}